import { EmptyState } from '@esnafai/shared/ui';
import { SearchX } from 'lucide-react';

export type NotFoundStateProps = {
  message: string;
  backTo: string;
  backLabel: string;
};

// A detail route's not-found state: the screen's sentence and a link back to its list (UI architecture §4).
export function NotFoundState({ message, backTo, backLabel }: NotFoundStateProps) {
  return <EmptyState message={message} icon={SearchX} action={{ label: backLabel, to: backTo }} />;
}
